import React, { useState, Fragment, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchDataActive, postData, updateData, fetchData1, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/material/IconButton';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import AddIcon from '@mui/icons-material/Add';
import { TableCell, Modal, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { Cloudinary } from 'cloudinary-core';
import {
    Search as SearchIcon,

    Edit as EditIcon,

    Category
} from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const MemberCreate = (props) => {


    const history = useHistory();
    const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
    const [localImageUrl, setLocalImageUrl] = useState('');
    const [cloudinaryImageUrl, setCloudinaryImageUrl] = useState('');
    const [memberId, setMemberId] = useState(0);
    const [memberId1, setMemberId1] = useState(null);
    const [memberId2, setMemberId2] = useState(null);
    const [memberName, setMemberName] = useState(null);
    const [firstname, setFirstName] = useState("");
    const [lastname, setLastName] = useState("");
    const [weddinganniversary, setWeddingAnniversary] = useState("");
    const [dateofjoining, setDateOfJoining] = useState("");
    const [dateofbirth, setDateOfBirth] = useState("");
    const [phonenumber, setPhoneNumber] = useState("");
    const [phonenumber1, setPhoneNumber1] = useState("");
    const [email, setEmail] = useState("");
    const [classification, setClassification] = useState("");
    const [dateofleaving, setDateOfLeaving] = useState("");
    const [remark, setRemark] = useState("");
    // const [bloodgroup, setBloodGroup] = useState("");
    const [gender, setGender] = useState(1);
    const [familyModalOpen, setFamilyModalOpen] = useState(false);
    const [dues, setDues] = useState("");
    const [status, setStatus] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSave, setIsSave] = useState(false);
    //----Child data--------------------------
    const [dateofbirthchild, setDateOfBirthChild] = useState("");
    const [profilePhoto, setProfilePhoto] = useState(null);
    const [selectedgroupchild, setselectedgroupchild] = useState("");
    const [uploadedImageName, setUploadedImageName] = useState('');
    const [uploadedImageUrl, setUploadedImageUrl] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [firmname, setFirmName] = useState("");
    const [professionorbusiness, setprofessionorbusiness] = useState("");
    const [residentialaddress, SetResidentialAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("Kerala");
    const [country, setCountry] = useState("India");
    const [deleteMember, setDeleteMember] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [onlineaccount, setOnlineaccount] = useState(1);
    const [rotaryrecognitions, setRecognitions] = useState(1);
    const [rotaryrecognitionsname, setRecognitionsName] = useState(1);
    const [category, setCategory] = useState(1);
    const cloudinary = new Cloudinary({ cloud_name: 'dm9pk2viy', secure: true });
    const [memberlist, setMemberOptions] = useState([]);
    const [postalcode, setPostalCode] = useState("");
    const [rotarydate, setRotaryDate] = useState("");
    const [editRecordData, setEditRecordData] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
     const [isRotarian, setRotarian] = useState(false);
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const localUrl = URL.createObjectURL(file);
            setProfilePhoto(localUrl);
            setSelectedFile(file);
        }
    };
    const handleMemberSelectChange = (selectedOption) => {
        setMemberId2(selectedOption);
    };
    const uploadImageToCloudinary = async (file, branchId, memberId, firstname) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'testupload'); // Replace with your upload preset
        formData.append('folder', `Rotary/member/${branchId}`); // Specify the folder structure
        formData.append('public_id', `${firstname}_${memberId}`); // Specify the public ID (file name without extension)

        try {
            const response = await axios.post(`https://api.cloudinary.com/v1_1/dm9pk2viy/image/upload`, formData);
            return response.data.secure_url; // URL of the uploaded image
        } catch (error) {
            console.error('Error uploading image to Cloudinary:', error);
            return null;
        }
    };

    //credit radio [customer type]
    const handleChange = (event) => {
        setGender(event.target.value);
    };
    const handleChange1 = (event) => {
        setCategory(event.target.value);
    };
    const openConfirmDialog = (memberId) => {
        setDeleteMember(memberId);
        setConfirmDialogOpen(true);
    };
    const handleChange2 = (event) => {
        setOnlineaccount(event.target.value);
    };
    const handleChange3 = (event) => {
        setRecognitions(event.target.value);


    };

    const handleEditClick = (record) => {
        setEditRecordData(record);
        setIsEditModalOpen(true);
    };

    const handleDelete = (index) => {
        const updatedData = familyData.filter((_, i) => i !== index); // Remove the record at `index`
        setFamilyData(updatedData); // Update state
    };

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, clubId, branchId, token, logout]);
    const fetchMember = async () => {
        try {
            const params1 = `/${clubId}`;
            const params2 = `?branchId=${branchId}`;
            // const response = await fetchData1('MemberApi', params1, params2, token);
            const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(member => ({
                    value: member.id,
                    label: member.firstName,
                }));
                setMemberOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Member:', error);
        }
    };
    const [bloodGroupOptions, setBloodGroupOptions] = useState([]);
    const [selectedgroup, setselectedgroup] = useState("");

    const fetchBloodGroup = async () => {
        try {
            const response = await fetchDataActive('MemberApi', token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(bgroup => ({
                    value: bgroup.id,
                    label: bgroup.group
                }));
                setBloodGroupOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Blood Group:', error);
        }
    };
    const handleBloodGroupChange = (selectedOption) => {
        setselectedgroup(selectedOption);
    };

    const handleBloodGroupChangechild = (selectedOption) => {
        setselectedgroupchild(selectedOption);
        setNewRecordData((prevData) => ({
            ...prevData,
            BloodGroupId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchBloodGroup();
        fetchMember();
    }, []);

    const clearForm = () => {
        setFirstName(""); setLastName("");
        setWeddingAnniversary(""); setDateOfJoining("");
        setDateOfBirth(""); setPhoneNumber("");
        setEmail(""); setDateOfLeaving("");
        setRemark("");
        setGender(""); setDues("");
        setStatus("");
    };

    const [isSubmitting, setIsSubmitting] = useState(false); // Track if submission is in progress

    const handleFormSubmit = (e) => {
        e.preventDefault();

        // Prevent form submission if already submitting
        if (isSubmitting) return;

        setIsSubmitting(true); // Set submission flag to true (disable the button)

        submitData(e); // Call submitData function for API request
    }

    const submitData = async (e) => {
        e.preventDefault();

        // Validation for required fields
        if (!firstname || !lastname || !dateofjoining||!memberId1||!dateofjoining||!rotarydate) //) 
        {
            setErrorMessage("All fields are required!");
            setIsSubmitting(false); // Reset the submission flag
            return;
        }
        const CreateData = {
            MemberId: memberId1,
            FirstName: firstname || null,  // Pass null if lastname is falsy
            LastName: lastname || null,  // Pass null if firstname is falsy
            WeddingAnniversary: weddinganniversary || null, //Rotary Date
            AdmittedDate: dateofjoining || null,  //Admitted Date
            DateOfBirth: dateofbirth || null,
            PhoneNumber: phonenumber || null,  // Null if phonenumber is falsy
            Email: email || null,  // Null if email is falsy
            Remark: remark || null,  // Null if remark is falsy
            CreatedBy: userId || null,  // Null if userId is falsy (unlikely for userId)
            CreatedDate: new Date(),  // Always generate the current date
            BloodGroupId: selectedgroup ? selectedgroup.value : null,  // Null if selectedgroup is falsy
            Gender: gender || null,  // Null if gender is falsy
            ClubId: clubId || null,  // Null if clubId is falsy
            UserTypeId: 1, // Default to 4 (doesn't need a null check)
            Expirydate: new Date(),
            DateOfLeaving: new Date(),
            BranchId: branchId,
            IsLoginNeeded: true,
            Profileguid: null,
            OriginalRotaryDate: rotarydate,
            ProposedByMemberId: memberId2 ? memberId2.value : null,
            Classification: classification,
            FirmName: firmname,
            Occupation: classification,
            Address: residentialaddress,
            City: city,
            State: state,
            PostalCode: postalcode,
            Country: country,
            PhoneNumber1: phonenumber1,
            RotaryRecognitions: "fdsf",
            RotaryRecognition: rotaryrecognitions,
            OnlineAccountwithmyRotary: onlineaccount,
            DateOfJoining: dateofjoining || null,  //Admitted Date

        };
        // Create child data (family members) from `familyData`
        const familyMembers = familyData.map(member => ({
            Name: member.Name || null,
            ClubId: clubId || null,
            DateOfBirth: member.DateOfBirthChild || null,
            BloodGroupId: member.BloodGroupId || null,
            Relation: member.Relation || null,
            CreatedBy: userId || null,
            CreatedDate: new Date(),
            isRotarian: member.isRotarian || false,
        }));

        const memberandfamilydata = {
            memberdata: CreateData,
            familydata: familyMembers, // Include child data as 'FamilyMembers'
        };

        try {
            // Proceed with the data submission logic
            const response = await postData('MemberApi', memberandfamilydata, token);
            console.log('Member created success:', response);

            const memberId = response.newId;
            setMemberId(memberId);
            setSuccessMessage("Member created successfully!");
            setErrorMessage("");
            history.push(`/MemberEdit/${memberId}`);
            // If there's a file, upload it
           // Upload image after member is created
            if (selectedFile) {
                const formData = new FormData();
                formData.append('file', selectedFile);
                formData.append('upload_preset', 'testupload'); // Replace with your upload preset
                formData.append('folder', `Rotary/member/${branchId}`); // Specify the folder structure
                const guidnew = uuidv4();
                const publicId = `${firstname}_${memberId}_${guidnew}`; // Generate a GUID and use it as the public ID
                formData.append('public_id', publicId); // Specify the public ID (file name without extension)

                //formData.append('public_id', `${firstname}_${memberId}`); // Specify the public ID (file name without extension)

                try {
                    const uploadResponse = await axios.post(`https://api.cloudinary.com/v1_1/dm9pk2viy/image/upload`, formData);
                    const imageUrl = uploadResponse.data.secure_url; // URL of the uploaded image
                    // setUploadedImageName(selectedFile.name);
                    //setUploadedImageUrl(imageUrl);
                } catch (error) {
                    console.error('Error uploading image to Cloudinary:', error);
                }
                //Update member data with image url
                const member = {
                    Id: memberId,
                    FirstName: firstname || null,  // Pass null if lastname is falsy
                    LastName: lastname || null,  // Pass null if firstname is falsy
                    WeddingAnniversary: weddinganniversary || null, //Rotary Date
                    AdmittedDate: dateofjoining || null,  //Admitted Date
                    DateOfBirth: dateofbirth || null,
                    PhoneNumber: phonenumber || null,  // Null if phonenumber is falsy
                    Email: email || null,  // Null if email is falsy
                    Remark: remark || null,  // Null if remark is falsy
                    CreatedBy: userId || null,  // Null if userId is falsy (unlikely for userId)
                    CreatedDate: new Date(),  // Always generate the current date
                    BloodGroupId: selectedgroup ? selectedgroup.value : null,  // Null if selectedgroup is falsy
                    Gender: gender || null,  // Null if gender is falsy
                    ClubId: clubId || null,  // Null if clubId is falsy
                    UserTypeId: 2, // Default to 4 (doesn't need a null check)
                    Expirydate: new Date(),
                    DateOfLeaving: new Date(),
                    BranchId: branchId,
                    IsLoginNeeded: true,
                    Profileguid: guidnew,
                    OriginalRotaryDate: rotarydate,
                    ProposedByMemberId: memberId2 ? memberId2.value : null,
                    Classification: classification,
                    FirmName: firmname,
                    Occupation: classification,
                    Address: residentialaddress,
                    City: city,
                    State: state,
                    PostalCode: postalcode,
                    Country: country,
                    PhoneNumber1: phonenumber1,
                    RotaryRecognitions: rotaryrecognitionsname,
                    RotaryRecognition: rotaryrecognitions,
                    OnlineAccountwithmyRotary: onlineaccount,
                    DateOfJoining: dateofjoining || null,  //Admitted Date
                    CategoryId: category,
                };

                try {
                    const response = await updateData('ProfileViewApi', memberId, member, token);
                    console.log('Record updated successfully:', response);

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);

                    //history.push('/MemberIndex');

                } catch (error) {
                    console.error('Error updating record:', error);
                }

            }

            clearForm();
            setTimeout(() => setSuccessMessage(""), 3000);
            history.push(`/MemberEdit/${memberId}`);
            window.location.reload();
        } catch (error) {
            console.error('M Create error:', error);
        } finally {
            setIsSubmitting(false); // Reset submission flag, enable the button
        }

    };


    //Family details add---------------------------------------------

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newRecordData, setNewRecordData] = useState({
        id: '',
        Name: '',
        DateOfBirthChild: '',
        BloodGroupId: '',
        Relation: '',
        bloodGroupName: '',
        isRotarian: false,
    });
    const [familyData, setFamilyData] = useState([]);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleModalclose = () => {
        setFamilyModalOpen(false);
    };

    const handleActivate = (memberId) => {
        activateData('MemberApi', `${memberId}`)
            .then(() => {
                // fetchData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const updateRecord = () => {
        setFamilyData((prevData) =>
            prevData.map((item) =>
                item.id === editRecordData.id ? editRecordData : item
            )
        );
       // Close the modal
        setIsEditModalOpen(false);
    };

    const addRecord = async () => {
        // Add new record to the table
        setFamilyData((prevData) => [...prevData, newRecordData]);
        if (memberId == 0) {
          if (!firstname || !lastname || !dateofjoining || !memberId1 || !rotarydate) {
            setErrorMessage("All fields are required!");
            return;
          }
         const CreateData = {
            MemberId: memberId1,
            FirstName: firstname || null,
            LastName: lastname || null,
            WeddingAnniversary: weddinganniversary || null,
            AdmittedDate: dateofjoining || null,
            DateOfBirth: dateofbirth || null,
            PhoneNumber: phonenumber || null,
            Email: email || null,
            Remark: remark || null,
            CreatedBy: userId || null,
            CreatedDate: new Date(),
            BloodGroupId: selectedgroup ? selectedgroup.value : null,
            Gender: gender || null,
            ClubId: clubId || null,
            UserTypeId: 1,
            Expirydate: new Date(),
            DateOfLeaving: new Date(),
            BranchId: branchId,
            IsLoginNeeded: true,
            Profileguid: null,
            OriginalRotaryDate: rotarydate,
            ProposedByMemberId: memberId2 ? memberId2.value : null,
            Classification: classification,
            FirmName: firmname,
            Occupation: classification,
            Address: residentialaddress,
            City: city,
            State: state,
            PostalCode: postalcode,
            Country: country,
            PhoneNumber1: phonenumber1,
            RotaryRecognitions: "fdsf", // might want to fix this
            RotaryRecognition: rotaryrecognitions,
            OnlineAccountwithmyRotary: onlineaccount,
            DateOfJoining: dateofjoining || null,
          };
      
          const familyMembers = [{
            Name: newRecordData.Name || null,
            Id: newRecordData.id || 0,
            ClubId: clubId,
            DateOfBirth: newRecordData.DateOfBirthChild || null,
            BloodGroupId: newRecordData.BloodGroupId || null,
            Relation: newRecordData.Relation || null,
            CreatedBy: newRecordData.id === 0 ? userId : newRecordData.createdBy,
            CreatedDate: newRecordData.id === 0 ? new Date() : newRecordData.createdDate,
            ModifiedBy: newRecordData.id === 0 ? userId : newRecordData.ModifiedBy,
            ModifiedDate: newRecordData.id === 0 ? new Date() : newRecordData.ModifiedDate,
            isRotarian: newRecordData.isRotarian,
      
          }];
      
          const memberandfamilydata = {
            memberdata: CreateData,
            familydata: familyMembers,
          };
      
          try {
            const response = await postData('MemberApi', memberandfamilydata, token);
            console.log('Member created success:', response);
      
            const newMemberId = response.newId;
            setMemberId(newMemberId);
            setSuccessMessage("Member created successfully!");
            setErrorMessage("");
            clearForm();
            setTimeout(() => setSuccessMessage(""), 3000);
            history.push(`/MemberEdit/${newMemberId}`);
            window.location.reload();
          } catch (error) {
            console.error('Member Create error:', error);
          }
        } else {
          // handle update logic if needed
        }
        setNewRecordData({
            id: '',
            Name: '',
            DateOfBirthChild: '',
            BloodGroupId: '',
            Relation: '',
            bloodGroupName: '',
            isRotarian: false,
          });
           // Close modal
        setIsModalOpen(false);
      };
      
    const togglefamilysModal = (recorddata = null) => {
        setFamilyModalOpen(true);

    };

    const handleDateOfBirthChange = (event) => {
        setNewRecordData((prevData) => ({
            ...prevData,
            DateOfBirthChild: event.target.value, // Directly update DateOfBirthChild
        }));
    };
    //-----------------------------Family details---------------

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">

                <div className="w-full flex justify-between items-center flex-wrap">
                    <h6 className='productHead linkcolor'
                        style={{ color: '#14528B', padding: '7px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                        MEMBER CREATE
                    </h6>

                    {/* <button
                        onClick={togglefamilysModal}
                        className="ml-3 text-blue-600 underline cursor-pointer"
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                    >
                        Family Datas
                    </button> */}

                    <div className="flex mt-2">
                        <Button
                            onClick={handleFormSubmit}
                            style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px' }}
                            disabled={isSubmitting} // Disable the button when submitting
                        >
                            Save
                        </Button>
                        <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#C62300', marginLeft: '5px', height: '25px' }}>
                            <Link to="/MemberIndex" className="linkcolor" style={{ textDecoration: 'none', color: 'inherit' }}>
                                CANCEL
                            </Link>
                        </Button>
                    </div>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full flex flex-wrap">
                    <div className="w-full sm:w-5/5 p-6 bg-white rounded-lg shadow-lg" style={{ width: '100%' }}>

                        <div className="w-full grid grid-cols-4 gap-2" style={{ marginTop: '-1.50%' }}>
                            <div>
                                <label htmlFor="memberId">Member Id
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={memberId1}
                                    onChange={(e) => setMemberId1(e.target.value)}
                                    type="text"

                                />
                            </div>
                            <div className="flex flex-col">
                                <label>
                                    Category<select
                                        name="category"
                                        value={category}
                                        onChange={handleChange1}
                                        className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                                    >
                                        <option value="1">General</option>
                                        <option value="2">Honorary</option>
                                        <option value="3">Emeritus</option>
                                        <option value="4">Corporate</option>

                                    </select>
                                </label>
                            </div>
                            <div>
                                <label htmlFor="name">First Name
                                <span className="text-red-500 ml-1">*</span>
                                </label>
                               
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={firstname}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    type="text"
                                    placeholder="Enter First Name"
                                />
                            </div>

                            <div>
                                <label htmlFor="lastname">Last Name
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={lastname}
                                    onChange={(e) => setLastName(e.target.value)}
                                    type="text"
                                    placeholder="Enter Last Name"
                                />
                            </div>
                        </div>

                        <div className="w-full grid grid-cols-4 gap-2">
                            <div>
                                <label htmlFor="email">Email
                                    {/* <span className="text-red-500 ml-1">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    placeholder="Enter Email"

                                />
                            </div>

                            <div>
                                <label htmlFor="phone">Phone(Country Code)
                                   {/*    <span className="text-red-500 ml-1">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={phonenumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                    type="text"
                                    placeholder="Set Phone Number"
                                />
                            </div>

                            <div>
                                <label htmlFor="phone">Phone(WhatsApp)
                                   {/*    <span className="text-red-500 ml-1">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={phonenumber1}
                                    onChange={(e) => setPhoneNumber1(e.target.value)}
                                    type="text"
                                    placeholder="Set Phone Number"
                                />
                            </div>
                            <div>
                                <label htmlFor="dateofbirth">Date Of Birth
                                     {/*    <span className="text-red-500 ml-1">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={dateofbirth}
                                    onChange={(e) => setDateOfBirth(e.target.value)}
                                    type="date"
                                    placeholder="Select Date Of Birth"
                                />
                            </div>


                        </div>

                        <div className="w-full grid grid-cols-4 gap-2">
                            <div>
                                <label htmlFor="dateofjoining">Admitted Date
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={dateofjoining}
                                    onChange={(e) => setDateOfJoining(e.target.value)}
                                    type="date"
                                    placeholder="Select Admitted Date"
                                />
                            </div>
                            <div>
                                <label htmlFor="weddinganniversary">Wedding Anniversary</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={weddinganniversary}
                                    onChange={(e) => setWeddingAnniversary(e.target.value)}
                                    type="date"
                                    placeholder="Select Rotary Date"
                                />
                            </div>
                            <div>
                                <label htmlFor="rotarydate">Rotary Date
                                <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={rotarydate}
                                    onChange={(e) => setRotaryDate(e.target.value)}
                                    type="date"
                                    placeholder="Select Rotary Date"
                                />
                            </div>
                            <div className="flex flex-col">
                                <label htmlFor="member">Proposed Member</label>
                                <Select
                                    value={memberId2}
                                    onChange={handleMemberSelectChange}
                                    options={memberlist}  // Use the same options as master
                                    placeholder="Select Member"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (base) => ({
                                            ...base,
                                            width: '100%',
                                            minHeight: '38px',
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '6px',
                                            padding: '2px 3px',
                                            fontSize: '14px'
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="w-full grid grid-cols-4 gap-2">
                            <div>
                                <label htmlFor="classification">Classification
                                 {/*    <span className="text-red-500 ml-1">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={classification}
                                    onChange={(e) => setClassification(e.target.value)}
                                    type="text"
                                    placeholder="Enter Classification"

                                />
                            </div>
                            <div>
                                <label htmlFor="firmname">Firm Name
                                   {/*    <span className="text-red-500 ml-1">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={firmname}
                                    onChange={(e) => setFirmName(e.target.value)}
                                    type="text"
                                    placeholder="Enter Firm Name"

                                />
                            </div>
                            <div>
                                <label htmlFor="professionorbusiness">Profession / Business
                                     {/*    <span className="text-red-500 ml-1">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={professionorbusiness}
                                    onChange={(e) => setprofessionorbusiness(e.target.value)}
                                    type="text"
                                    placeholder="Enter Profession / Business"

                                />
                            </div>
                            <div>
                                <label htmlFor="residentialaddress">Residential Address
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={residentialaddress}
                                    onChange={(e) => SetResidentialAddress(e.target.value)}
                                    type="residentialaddress"
                                    placeholder="Enter Residential Address"

                                />
                            </div>
                        </div>
                        <div className="w-full grid grid-cols-4 gap-2">
                            <div>
                                <label htmlFor="city">City
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    type="text"
                                    placeholder="Enter City"

                                />
                            </div>
                            <div>
                                <label htmlFor="state">State
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}
                                    type="text"
                                    placeholder="Enter State"

                                />
                            </div>
                            <div>
                                <label htmlFor="country">Country
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                    type="text"
                                    placeholder="Enter Country"

                                />
                            </div>
                            <div>
                                <label htmlFor="postalcode">Postal Code
                                    {/*    <span className="text-red-500 ml-1">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={postalcode}
                                    onChange={(e) => setPostalCode(e.target.value)}
                                    type="text"
                                    placeholder="Enter Postal Code"

                                />
                            </div>
                        </div>




                        <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">

                            <div className="flex flex-col">
                                <label>
                                    Rotary Recognitions<select
                                        name="rotaryrecognitions"
                                        value={rotaryrecognitions}
                                        onChange={handleChange3}
                                        className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                                    >
                                        <option value="1">PHF</option>
                                        <option value="2">AKS</option>
                                        <option value="3">MD</option>
                                    </select>
                                </label>
                            </div>
                            <div className="flex flex-col">
                                <label>
                                    Online Account with Rotary<select
                                        name="onlineaccount, "
                                        value={onlineaccount}
                                        onChange={handleChange2}
                                        className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                                    >
                                        <option value="1">Yes</option>
                                        <option value="2">No</option>

                                    </select>
                                </label>
                            </div>

                            <div className="flex flex-col">
                                <label htmlFor="weddinganniversary" className="text-sm font-medium"> Blood Group</label>

                                <Select
                                    value={selectedgroup}
                                    onChange={handleBloodGroupChange}
                                    options={bloodGroupOptions}  // Use the same options as master
                                    placeholder="Bld Grp"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (base) => ({
                                            ...base,
                                            width: '100%',
                                            minHeight: '38px',
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '6px',
                                            padding: '2px 3px',
                                            fontSize: '14px'
                                        })
                                    }}
                                />




                            </div>

                            <div className="flex flex-col">
                                <label htmlFor="gender" className="text-sm font-medium">Gender</label><select
                                    name="gender"
                                    value={gender}
                                    onChange={handleChange}
                                    className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                                >
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                    <option value="3">Others</option>
                                </select>

                            </div>
                        </div>




                        <div className="w-full grid grid-cols-1 gap-2">

                            <div>
                                <label htmlFor="name">Remark</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                    type="text"
                                    placeholder="Remark"
                                />
                            </div>

                        </div>
                        <br></br>


                        <div
                            style={{
                                width: '250px',
                                padding: '20px',
                                border: '2px solid #ccc',
                                borderRadius: '10px',
                                backgroundColor: '#fafafa',
                                textAlign: 'center',
                            }}
                        >
                            <div className="flex flex-col items-center">



                                <input type="file" accept="image/*" onChange={handleFileUpload} />
                                <div>
                                    {profilePhoto ? (
                                        <img
                                            src={profilePhoto}
                                            alt="Selected"
                                            style={{
                                                objectFit: 'cover',
                                                maxWidth: '100%',
                                                maxHeight: '200px',
                                            }}
                                        />
                                    ) : (
                                        <span>No photo uploaded</span>
                                    )}
                                </div>
                                {uploadedImageName && <p>Uploaded Image: {uploadedImageName}</p>}
                                {uploadedImageUrl && <img src={uploadedImageUrl} alt="Uploaded" style={{ width: '200px', height: '200px' }} />}
                            </div>
                        </div>

                    </div>
                    {/* toggle window */}

                    {isModalOpen && (
                        <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                            <div className="fixed inset-0 flex items-center justify-center z-50">
                                <div className="bg-white p-6 rounded-lg  w-full sm:w-1/2" style={{ maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>
                                    <div className="w-full mb-4 flex">
                                    

                                        <div className="w-1/10 mr-2">

                                            <label htmlFor="name">
                                                Name <span className="text-red-500 ml-1">*</span> {/* Star symbol */}
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                type="text"
                                                name="Name"
                                                placeholder="Enter Name"
                                                value={newRecordData.Name}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label htmlFor="dateofbirth">Date Of Birth
                                                <span className="text-red-500 ml-1">*</span> {/* Star symbol */}
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={newRecordData.DateOfBirthChild} // Use newRecordData for value
                                                onChange={handleDateOfBirthChange} // Use the correct onChange handler
                                                type="date"
                                                name="DateOfBirthChild" // Ensure the name matches your state field
                                                placeholder="Select Date Of birth"
                                            />
                                        </div>

                                    </div>
                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/4 mr-2">
                                            <label htmlFor="bgroup">
                                                Blood Group
                                            </label>

                                            <Select
                                                value={selectedgroupchild}
                                                onChange={handleBloodGroupChangechild}
                                                options={bloodGroupOptions}  // Use the same options as master
                                                placeholder="Bld Grp"
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: '38px',
                                                        border: '1px solid #D1D5DB',
                                                        borderRadius: '6px',
                                                        padding: '2px 3px',
                                                        fontSize: '14px'
                                                    })
                                                }}
                                            />

                                        </div>

                                        <div className="w-1/4 mr-2">
                                            <label htmlFor="Relation">
                                                Relation  <span className="text-red-500 ml-1">*</span> {/* Star symbol */}
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                type="text"
                                                name="Relation"
                                                placeholder="Enter Relation"
                                                value={newRecordData.Relation}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                 <div className="flex items-center">
                                  <input
                                        type="checkbox"
                                        id="isRotarian"
                                        name="entityType"
                                        value="isRotarian"
                                        checked={isRotarian}
                                        onChange={() => {
                                            const newValue = !isRotarian; // Toggle value
                                            setRotarian(newValue);

                                           }}
                                    />


                                    
                                    <label htmlFor="isRotarian" className="ml-2">Is Rotarian</label>
                                </div>
                                    </div>

                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                                        <Button
                                            style={{ backgroundColor: '#22c55e', color: 'white', padding: '8px 16px', borderRadius: '4px' }}
                                            onClick={addRecord}
                                        > Add Record
                                        </Button>
                                        <Button
                                            style={{ backgroundColor: '#3b82f6', color: 'white', padding: '8px 16px', borderRadius: '4px', marginLeft: '8px' }}
                                            onClick={() => setIsModalOpen(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    )}

                    {isEditModalOpen && (
                        <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
                            <div className="fixed inset-0 flex items-center justify-center z-50">
                                <div className="bg-white p-6 rounded-lg w-full sm:w-1/2"
                                    style={{ maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>
                                    <h2 className="text-lg font-bold mb-4">Edit Member Family Details</h2>

                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/10 mr-2">
                                            <label>Name <span className="text-red-500 ml-1">*</span></label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
                                                type="text"
                                                name="Name"
                                                placeholder="Enter Name"
                                                value={editRecordData?.Name || ''}
                                                onChange={(e) => setEditRecordData({ ...editRecordData, Name: e.target.value })}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label>Date Of Birth <span className="text-red-500 ml-1">*</span></label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
                                                type="date"
                                                name="DateOfBirthChild"
                                                value={editRecordData?.DateOfBirthChild || ''}
                                                onChange={(e) => setEditRecordData({ ...editRecordData, DateOfBirthChild: e.target.value })}
                                            />
                                        </div>

                                      
                                    </div>

                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/4 mr-2">
                                        <label>Blood Group</label>
                                            <Select
                                                value={bloodGroupOptions.find(option => option.value === editRecordData?.BloodGroupId)}
                                                onChange={(selectedOption) => setEditRecordData({ ...editRecordData, BloodGroupId: selectedOption.value })}
                                                options={bloodGroupOptions}  // Use the same options as master
                                                placeholder="Bld Grp"
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: '38px',
                                                        border: '1px solid #D1D5DB',
                                                        borderRadius: '6px',
                                                        padding: '2px 3px',
                                                        fontSize: '14px'
                                                    })
                                                }}
                                            />
                                        </div>
                                        <div className="w-1/4 mr-2">
                                            <label>Relation <span className="text-red-500 ml-1">*</span></label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
                                                type="text"
                                                name="Relation"
                                                placeholder="Enter Relation"
                                                value={editRecordData?.Relation || ''}
                                                onChange={(e) => setEditRecordData({ ...editRecordData, Relation: e.target.value })}
                                            />
                                        </div>
                                        <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="isRotarian"
                                        name="isRotarian"
                                        value="isRotarian"
                                        checked={editRecordData.isRotarian}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="isRotarian" className="ml-2">Rotarian</label>
                                </div>
                                    </div>

                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                                        <Button
                                            style={{ backgroundColor: '#22c55e', color: 'white', padding: '8px 16px', borderRadius: '4px' }}
                                            onClick={updateRecord}
                                        > Update Record
                                        </Button>
                                        <Button
                                            style={{ backgroundColor: '#3b82f6', color: 'white', padding: '8px 16px', borderRadius: '4px', marginLeft: '8px' }}
                                            onClick={() => setIsEditModalOpen(false)}
                                        > Cancel
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    )}



                    <Modal open={familyModalOpen} onClose={() => setFamilyModalOpen(false)}>
                        {/* <div className="w-full sm:w-2/5 pl-2">
                                <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto' }}> */}
                        <div className="fixed inset-0 flex items-center justify-center z-70">
                            <div className="bg-white p-6 rounded-lg  w-full sm:w-1/2" style={{ maxHeight: '90vh', overflowY: 'auto', overflow: 'visible' }}>

                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                            <TableRow>
                                                <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '7px', fontSize: '16px', fontWeight: 'bold' }}>Member Family Details</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Sl No</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Name</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>DOB</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Blood Group</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Relation</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '2px' }}>
                                                    <IconButton onClick={toggleModal} aria-label="add">
                                                        <AddIcon style={{ color: 'green' }} />
                                                    </IconButton>
                                                    <IconButton onClick={toggleModalclose} aria-label="add">
                                                        <span style={{ fontSize: '14px', color: 'red' }}>X</span>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {familyData.map((childdata, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>
                                                        {childdata.Name}
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>
                                                        {childdata.DateOfBirthChild} {/* Make sure you're displaying the date */}
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>
                                                        {bloodGroupOptions.find((option) => option.value === childdata.BloodGroupId)?.label}
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>
                                                        {childdata.Relation}
                                                    </TableCell>

                                                    <TableCell sx={{ height: '40px', padding: '5px', textAlign: 'center', padding: '2px' }}>

                                                        <IconButton onClick={() => handleEditClick(childdata, index)}>
                                                            <EditIcon style={{ fontSize: '20px', color: 'blue' }} />
                                                        </IconButton>

                                                        <IconButton onClick={() => handleDelete(index)}>
                                                            <DeleteIcon style={{ fontSize: '20px', color: 'brown' }} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </Modal>
                </div>

            </div >


        </Fragment >
    );
}

export default MemberCreate;